export default function(
  { filter = null, limit, offset, sort },
  baseFilter,
  options = {}
) {
  const { disableTotalRow } = options

  const query = filter ? `&filter=${filter}` : ''

  const baseQuery = baseFilter
    ? `&filter=and(${baseFilter}${filter ? `,${filter}` : ''})`
    : query

  const firstRow = (offset && `&firstRow=${offset}`) || ''

  const maxRows = (limit && `&maxRows=${limit}`) || ''

  const getTotalRowCount = !disableTotalRow ? '&getTotalRowCount=true' : ''

  let sortQuery = (sort && `&sort=${sort}`) || ''

  if (!sort && options.baseSort) {
    sortQuery = `&sort=${options.baseSort}`
  }

  return `${baseQuery}${maxRows}${firstRow}${getTotalRowCount}${sortQuery}`
}
